import React from "react";
import Heading from "../../common/Heading";
import "./style.css";

const socialMedia = [
  { name: "WhatsApp", icon: "./images/whatsapp.png", link: "https://wa.me/+250780316256" },
  { name: "Call", icon: "./images/call.png", link: "tel:+250780316256" },
  { name: "SMS", icon: "./images/sms.png", link: "sms:+250780316256" },
  { name: "Instagram", icon: "./images/instagram.png", link: "https://instagram.com/your-profile" },
  { name: "Facebook", icon: "./images/facebook.png", link: "https://facebook.com/your-profile" },
  { name: "Twitter", icon: "./images/twitter.png", link: "https://twitter.com/your-profile" }
];

const SocialMedia = () => {
  return (
    <>
      <section className='social-media padding'>
        <div className='container'>
          <Heading 
            title='Connect With Us' 
            subtitle='Follow us on social media to stay updated with our latest news, trends, and promotions. Join our community and engage with us on your favorite platforms!'
          />

          <div className='content grid3 mtop'>
            {socialMedia.map((platform, index) => (
              <div className='box' key={index}>
                <img src={platform.icon} alt={platform.name} className='icon small-icon'/>
                <div className='overlay'>
                  <h5>{platform.name}</h5>
                  <a href={platform.link} target='_blank' rel='noopener noreferrer' className='follow-btn'>
                    Follow
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default SocialMedia;
